/**
 * always resolving promise in predefined time with predefined value
 *
 * @param {number} time
 * @param result
 * @returns {Promise<any>}
 */
export function timedPromise(time: number = 1000, result: any = true): Promise<any> {
    return new Promise(resolve => {
        setTimeout(resolve.bind(resolve, result), time)
    })
}
